import React from 'react';
import { ProjectFormData, RtdKonto } from './SubscriptionToProjectWizardTypes';

interface Step1Props {
    projectData: ProjectFormData;
    setProjectData: React.Dispatch<React.SetStateAction<ProjectFormData>>;
    rtdKontos: RtdKonto[];
    loadingRtdKontos: boolean;
}

const SubscriptionToProjectWizardStep1: React.FC<Step1Props> = ({
    projectData,
    setProjectData,
    rtdKontos,
    loadingRtdKontos
}) => {
    return (
        <div className="subToProjWiz-wizard-step">
            <h3>Projekt-Parameter</h3>
            <p className="subToProjWiz-step-description">
                Geben Sie die grundlegenden Informationen für das neue Projekt ein.
            </p>

            <div className="subToProjWiz-form-group">
                <label htmlFor="projectName">
                    Projektname <span className="subToProjWiz-required">*</span>
                </label>
                <input
                    id="projectName"
                    type="text"
                    className="subToProjWiz-form-control"
                    value={projectData.name}
                    onChange={(e) => setProjectData({ ...projectData, name: e.target.value })}
                    placeholder="z.B. Jahresbeitrag 2024"
                    required
                />
            </div>

            <div className="subToProjWiz-form-group">
                <label htmlFor="projectDescription">Beschreibung</label>
                <textarea
                    id="projectDescription"
                    className="subToProjWiz-form-control"
                    value={projectData.description}
                    onChange={(e) => setProjectData({ ...projectData, description: e.target.value })}
                    placeholder="Optionale Beschreibung des Projekts"
                    rows={3}
                />
            </div>

            <div className="subToProjWiz-form-group">
                <label htmlFor="projectStatus">Status</label>
                <select
                    id="projectStatus"
                    className="subToProjWiz-form-control"
                    value={projectData.status}
                    onChange={(e) => setProjectData({ ...projectData, status: e.target.value as 'OPEN' | 'CLOSED' | 'ARCHIVED' })}
                >
                    <option value="OPEN">Offen</option>
                    <option value="CLOSED">Geschlossen</option>
                    <option value="ARCHIVED">Archiviert</option>
                </select>
            </div>

            <div className="subToProjWiz-form-group">
                <label htmlFor="rtdKontoId">RTD Konto</label>
                {loadingRtdKontos ? (
                    <div className="subToProjWiz-loading-text">Lade RTD Konten...</div>
                ) : (
                    <select
                        id="rtdKontoId"
                        className="subToProjWiz-form-control"
                        value={projectData.rtdKontoId ?? ''}
                        onChange={(e) => setProjectData({
                            ...projectData,
                            rtdKontoId: e.target.value ? Number(e.target.value) : null
                        })}
                    >
                        <option value="">Kein Konto</option>
                        {rtdKontos.filter(k => k.active).map((konto) => (
                            <option key={konto.id} value={konto.id}>
                                {konto.accountName} ({konto.iban})
                            </option>
                        ))}
                    </select>
                )}
            </div>
        </div>
    );
};

export default SubscriptionToProjectWizardStep1;
